export enum ECoworkingAccess {
  AllDayAccess = 1,
  AllWeekAccess = 2,
}
